module.exports = __webpack_public_path__ + "static/media/stars.db2b9387.svg";